import React from 'react';
import './MenuItem.css';
import { Category } from '../../data/RowData';
import { useAppContext } from '../../services/AppService';

type Props = {
	name: string;
	onClick: (index: number) => void;
	index: number;
}

export const MenuItem: React.FC<Props> = ({name, onClick, index}: Props) => {
	const { state } = useAppContext();

	const createMenu = (): JSX.Element => {
		if (state.category === Category.all) {
			return <span className='menu-item' onClick={() => onClick(index)}>{name.toUpperCase()}</span>;
		} else {
			if (state.category === name) {
				return <span className='menu-item-selected' onClick={() => onClick(index)}>{name.toUpperCase()}</span>
			} else {
				return <span className='menu-item' onClick={() => onClick(index)}>{name.toUpperCase()}</span>;
			}
		} 
	}

	return (
		<>
			{createMenu()}
		</>
	)
}